var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',[_c('span',[_vm._v("© 2020 中央研究院 中國文哲研究所 All rights reserved 【本網站獲科技部人文社會科學研究中心經費補助】")])])])}]

export { render, staticRenderFns }